









































import {ErrorInfo} from '@/store/modules/layout/types'
import {Component, Prop, Vue} from 'vue-property-decorator'
import ErrorItem from './ErrorItem.vue'

@Component({
  components: {
    ErrorItem,
  },
})
export default class ErrorLayout extends Vue {
  @Prop() errors: ErrorInfo[]
  @Prop({default: 2}) maxShow: number

  get filteredErrors() {
    const {maxShow} = this
    return this.errors.filter((_, index) => {
      return index < maxShow
    })
  }
}
